<template>
    <div class="ribbon-actions text-right">
        <v-btn flat
               @click="handleCancel()"
               :data-qe-id="`community-directory_${currentRibbon.key || ''}_cancel_filter_btn`"
               class="bold-font ypo_blue_color ribbon-actions__button">
            {{appCommonConstants.CANCEL}}
        </v-btn>
        <v-btn
                color="primary"
                :disabled="isDisabled()"
                @click="handleApply()"
                :data-qe-id="`community-directory_${currentRibbon.key || ''}_apply_filter_btn`"
                class="ribbon-actions__button">
            <span class="ribbon-actions__button-label">{{appCommonConstants.APPLY}}</span>
            <span v-if="newlySelectedFilterNumber"
                  :data-qe-id="`community-directory_${currentRibbon.key || ''}_selected-filter-count`">
                ({{newlySelectedFilterNumber}})
            </span>
        </v-btn>
    </div>
</template>
<script>
    import { appCommonConstants } from "../appCommon.constants";

    export default {
        name: 'CommunityRibbonActionButtons',
        props: {
            isDisabled: {
                type: Function,
                required: true,
            },
            handleCancel: {
                type: Function,
                required: true,
            },
            handleApply: {
                type: Function,
                required: true,
            },
            newlySelectedFilterNumber: {
                type: Number,
                default: null,
            },
            currentRibbon: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                appCommonConstants,
            };
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';

  .ribbon-actions {
      &__button {
          &-label {
              padding-right: 5px;
          }
      }
  }

</style>

<style lang="scss">

    .ribbon-actions__button {
        .v-btn__content {
            text-transform: none !important;
        }
    }
</style>
